import React from 'react';

export const AlarmFilledIcon = ({ width = 32, height = 32, color = "white", className }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 32 32"
            fill="none"
        >
            <path
                className={className}
                d="M15.9999 2.66666C13.5246 2.66666 11.1506 3.64999 9.40028 5.40033C7.64995 7.15067 6.66661 9.52464 6.66661 12V16.704C6.66681 16.9108 6.61888 17.1149 6.52661 17.3L4.23728 21.8773C4.12545 22.101 4.07264 22.3495 4.08388 22.5992C4.09511 22.849 4.17002 23.0918 4.30147 23.3044C4.43293 23.5171 4.61658 23.6927 4.83497 23.8144C5.05336 23.9361 5.29925 24 5.54928 24H26.4506C26.7006 24 26.9465 23.9361 27.1649 23.8144C27.3833 23.6927 27.567 23.5171 27.6984 23.3044C27.8299 23.0918 27.9048 22.849 27.916 22.5992C27.9273 22.3495 27.8744 22.101 27.7626 21.8773L25.4746 17.3C25.3819 17.115 25.3335 16.9109 25.3333 16.704V12C25.3333 9.52464 24.35 7.15067 22.5996 5.40033C20.8493 3.64999 18.4753 2.66666 15.9999 2.66666ZM15.9999 28C15.1724 28.0004 14.3651 27.7442 13.6893 27.2666C13.0135 26.789 12.5025 26.1135 12.2266 25.3333H19.7733C19.4974 26.1135 18.9864 26.789 18.3106 27.2666C17.6348 27.7442 16.8275 28.0004 15.9999 28Z"
                fill={color}
            />
        </svg>
    );
};